import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';

let $ = window.jQuery;

export default class ToothComponent extends Component {
    static propTypes = {
        procedure: PropTypes.string,
        color: PropTypes.string.isRequired,
        toothId: PropTypes.string.isRequired,
        toothData: PropTypes.array.isRequired,
        errorCallback: PropTypes.func.isRequired,
        successCallback: PropTypes.func.isRequired
    };

    state = {
        color: 'blue',
        toothData: [],
        procedure: ''
    };

    handleChangeFill = (e) => {
        if (this.state.color === '') {
            $('#toothSurfaceValidation').modal('show');

            return false;
        }

        if (e.target.style.fill !== null && e.target.style.fill !== '') {
            this.clearSingleShard(e.target);

            return false;
        }

        this.fillTooth(e.target.id);
    };

    fillTooth = (shardId) => {
        let index = this.toothDataHasValue();

        if (! index) {
            // Create a new tooth data element
            this.createNewToothData(shardId);
        } else {
            // Check if shardId already filled, Just update that
            let shardIndex = this.findShardId(shardId);
            if (shardIndex >= 0) {
                // Update the shard only
                this.updateToothDataShard(shardIndex, shardId);
            } else {
                // Update Existing tooth data element
                this.updateToothData(shardId);
            }
        }

        this.props.successCallback('Successfully mapped');
    };

    toothDataHasValue = () => {
        return (typeof this.state.toothData === 'object'
            && this.state.toothData.length > 0
            && typeof this.state.toothData[0].fills !== 'undefined');
    };

    findShardId = (shardId) => {
        let data = this.state.toothData[0];

        return data.fills.findIndex((shard) => {
            return shard.shard_id === shardId;
        });
    };

    createNewToothData = (shardId) => {
        let data = {
            tooth_id: this.props.toothId,
            procedure_abbr: this.state.procedure,
            color: this.state.color,
            type: this.props.chartType,
            dental_chart_id: this.props.selectedChart.id,
            procedure_id: this.props.procedureId,
            fills: [
                {
                    shard_id: shardId
                }
            ]
        };

        this.setState({
            toothData: [data]
        }, () => {
            this.mapExistingFills();
            this.props.onUpdatedTempToothData(this.state.toothData[0]);
        });
    };

    updateToothData = (shardId) => {
        //console.log(this.props.procedureId);

        let data = this.state.toothData[0];
        data.procedure_abbr = this.state.procedure;
        data.color = this.state.color;
        data.fills = data.fills.concat([{shard_id: shardId}]);
        data.procedure_id = this.props.procedureId;

        let toothData = this.state.toothData;
        toothData[0] = data;

        this.setState({
            toothData
        }, () => {
            this.mapExistingFills();
            this.props.onUpdatedTempToothData(this.state.toothData[0]);
        });
    };

    updateToothDataShard = (shardIndex, shardId) => {
        let data = this.state.toothData[0];
        data.procedure_abbr = this.state.procedure;
        data.color = this.state.color;
        data.procedure_id = this.props.procedureId;

        data.fills[shardIndex] = {
            shard_id: shardId
        };

        let toothData = this.state.toothData;
        toothData[0] = data;

        this.setState({
            toothData
        }, () => {
            this.mapExistingFills();
            this.props.onUpdatedTempToothData(this.state.toothData[0]);
        });
    };

    mapExistingFills = () => {
        if (this.state.toothData.length <= 0) {
            return false;
        }


        if (typeof this.state.toothData[0].fills === 'undefined') {
            return false;
        }

        if (this.state.toothData[0].fills.length <= 0) {

            return false;
        }

        // console.log(this.state.toothData[0]);

        this.state.toothData[0].fills.forEach((item, i) => {
            let shard = ReactDOM.findDOMNode(this.refs[item.shard_id]);
            shard.style.fill = this.state.toothData[0].color;
        });
    };

    clearSingleShard = (target) => {
        let shardId = target.id;
        let data = this.state.toothData[0];
        let shardIndex = data.fills.findIndex((item) => {

            // eslint-disable-next-line
            return item.shard_id == shardId;
        });

        if (shardIndex < 0) {
            return false;
        }

        target.style.fill = null;
        data.fills.splice(shardIndex, 1);

        let toothData = this.state.toothData;
        // console.log('removed shard: ', data);
        toothData[0] = data;

        this.setState({
            toothData
        }, () => {
            this.mapExistingFills();
            this.props.onUpdatedTempToothData(this.state.toothData[0]);
        });
    };

    handleDoubleClick = (e) => {
        // e.target.style.fill = null;
        this.clearSingleShard(e.target);
    };

    handleClearTooth = () => {
        this.setState({
            toothData: []
        });

        let rightShard = ReactDOM.findDOMNode(this.refs['rightShard']);
        let topShard = ReactDOM.findDOMNode(this.refs['topShard']);
        let bottomShard = ReactDOM.findDOMNode(this.refs['bottomShard']);
        let leftShard = ReactDOM.findDOMNode(this.refs['leftShard']);
        let middleShard = ReactDOM.findDOMNode(this.refs['middleShard']);

        rightShard.style.fill = null;
        topShard.style.fill = null;
        bottomShard.style.fill = null;
        leftShard.style.fill = null;
        middleShard.style.fill = null;
    };

    fillAllShards = (props) => {
        let shards = [
            {
                shard_id: 'rightShard'
            },
            {
                shard_id: 'topShard'
            },
            {
                shard_id: 'leftShard'
            },
            {
                shard_id: 'bottomShard'
            },
            {
                shard_id: 'middleShard'
            }
        ];

        let data = [{
            tooth_id: props.toothId,
            procedure_abbr: props.procedure,
            color: props.color,
            type: props.chartType,
            dental_chart_id: props.selectedChart.id,
            procedure_id: props.procedureId,
            fills: shards
        }];

        this.setState({
            toothData: data
        }, () => {
            this.mapExistingFills();
            this.props.onUpdatedTempToothData(this.state.toothData[0]);
        })
    };

    componentDidMount() {
        if (this.props.toothData.length > 0) {
            this.setState({
                color: this.props.color,
                toothData: this.props.toothData[0],
                procedure: this.props.procedure
            }, () => {
                this.mapExistingFills();
            });
        }

        $('#setTooth').on('shown', () => {
            this.handleClearTooth();
        });
    }

    componentWillReceiveProps(nextProps) {
        // console.log(nextProps.charting.data);
        let oldDataIndex = nextProps.charting.data.findIndex((item) => {
            // console.log(item.tooth_id + '==' + nextProps.toothNumber);
            // console.log(item.type + '==' + nextProps.chartType);
            // eslint-disable-next-line
            return item.tooth_id == nextProps.toothNumber && item.type == nextProps.chartType;
        });

        let toothData = this.state.toothData;

        // check if tooth number is not the same as the last one
        if (nextProps.toothNumber !== this.props.toothNumber) {
            // Clear the data and tooth
            this.handleClearTooth();
            toothData = [];
        }

        // If toothdata has no value yet
        if (toothData.length <= 0) {
            // Apply color and procedure
            toothData.push({
                color: nextProps.color,
                procedure_abbr: nextProps.procedure,
                procedure_id: nextProps.procedureId
            });
        } else {
            // Apply color and procedure
            toothData[0].color = nextProps.color;
            toothData[0].procedure_abbr = nextProps.procedure;
            toothData[0].procedure_id = nextProps.procedureId;
        }

        // If this tooth has an old data inputted/filled into it
        if (oldDataIndex >= 0) {
            // Assign that as new object
            toothData[0] = Object.assign({}, nextProps.charting.data[oldDataIndex], toothData[0]);
        }

        this.setState({
            color: nextProps.color,
            procedure: nextProps.procedure,
            toothData
        }, () => {
            this.mapExistingFills();
        });

        if (this.props.procedure !== nextProps.procedure) {
            switch (nextProps.procedure) {
                case 'M':
                case 'MO':
                case 'X':
                case 'XO':
                case '✔':
                    // console.log(nextProps.charting.data[oldDataIndex]);
                    if (oldDataIndex > 0) {
                        if (nextProps.charting.data[oldDataIndex].procedure_abbr !== nextProps.procedure) {
                            this.fillAllShards(nextProps);
                        }
                    } else {
                        this.fillAllShards(nextProps);
                    }
                    break;
                default:
                // Do nothing
            }
        }
    }

    render() {
        return (
            <div id={this.props.toothId}>
                <svg viewBox="0 0 11738000 11737976">
                 <g id="Layer_x0020_1">
                  <metadata id="CorelCorpID_0Corel-Layer"/>
                  <g id="_720061432">
                   <circle className="fil0 str0" cx="5868998" cy="5868990" r="5551194"/>
                   <path onClick={this.handleChangeFill} onDoubleClick={this.handleDoubleClick} className="fil0 str1" ref="topShard" id="topShard" d="M5868964 317803c1532974,0 2920806,621310 3925317,1625916l-1975821 1975822c-498914,-498914 -1188128,-807504 -1949424,-807504 -761319,0 -1450581,308590 -1949495,807504l-1975822 -1975822c1004559,-1004559 2392343,-1625916 3925245,-1625916z"/>
                   <path onClick={this.handleChangeFill} onDoubleClick={this.handleDoubleClick} className="fil0 str2" ref="leftShard" id="leftShard" d="M1943719 1943719l1975870 1975870c-498891,498914 -807505,1188104 -807505,1949375 0,761320 308614,1450582 807505,1949472l-1975870 1975821c-1004606,-1004487 -1625916,-2392343 -1625916,-3925293 0,-1532902 621310,-2920686 1625916,-3925245z"/>
                   <path onClick={this.handleChangeFill} onDoubleClick={this.handleDoubleClick} className="fil0 str3" ref="bottomShard" id="bottomShard" d="M7818460 7818436l1975821 1975821c-1004559,1004607 -2392343,1625916 -3925317,1625916 -1532902,0 -2920686,-621309 -3925245,-1625916l1975822 -1975821c498914,498914 1188176,807456 1949495,807456 761296,0 1450510,-308542 1949424,-807456z"/>
                   <path onClick={this.handleChangeFill} onDoubleClick={this.handleDoubleClick} className="fil0 str4" ref="rightShard" id="rightShard" d="M7818460 7818388l1975821 1975822c1004535,-1004559 1625916,-2392296 1625916,-3925198 0,-1532902 -621309,-2920734 -1625916,-3925293l-1975821 1975822c498890,498890 807504,1188104 807504,1949423 0,761320 -308662,1450534 -807504,1949424z"/>
                   <circle onClick={this.handleChangeFill} onDoubleClick={this.handleDoubleClick} className="fil0 str5" ref="middleShard" id="middleShard" cx="5869011" cy="5868976" r="2756925"/>
                  </g>
                 </g>
                </svg>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Charting/ToothComponent.js
 **/